export default {"src":"/_next/static/media/next_track.1267d28c.svg","height":11,"width":9,"blurWidth":0,"blurHeight":0};